export const ERROR_MESSAGES = {
  LICENSE: '＊「お持ちの資格」を少なくとも１つ選択してください',
  EXPERIENCE: '＊「ご経験」を少なくとも１つ選択してください',
  PREFECTURE: '＊「都道府県」を選択してください',
  BIRTHYEAR: '＊「生まれた年」を選択してください',
  NAME: '＊「お名前」を入力してください',
  TEL: '＊10桁か11桁の番号を入力してください',
  EMAIL: '＊正しい「メールアドレス」を入力してください',
  TERMS: '＊利用規約に同意してください',
};

export const CSRF_TOKEN = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content');
